// extracted by mini-css-extract-plugin
export default {"root":"Option_root__cLN6D","remove":"Option_remove__Do0R4","body":"Option_body__gFfWR","clickable":"Option_clickable__fvHmf"};